import React, { PureComponent } from 'react';
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    BarChart,
    Bar,
    ResponsiveContainer,
    Cell,
} from 'recharts';

export const AreaCharts = ({ dataKeyXaxis, dataKeyArea, chartData, customToolTip }) => {
    // Define colors for weekday and weekend bars
    const WEEKDAY_COLOR = '#4169E1'; // Blue for weekdays
    const WEEKEND_COLOR = '#FF6B6B'; // Red/Pink for weekends

    // Prepare data with color information
    const dataWithColors = chartData.map((item) => ({
        ...item,
        fill: item.isWeekend ? WEEKEND_COLOR : WEEKDAY_COLOR,
    }));

    return (
        <div style={{ width: '100%' }}>
            <ResponsiveContainer width="100%" height={293}>
                <BarChart
                    width={500}
                    height={200}
                    data={dataWithColors}
                    syncId="anyId"
                    margin={{
                        top: 10,
                        right: 30,
                        left: 0,
                        bottom: 60,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis 
                        dataKey={dataKeyXaxis}
                        angle={-45}
                        textAnchor="end"
                        height={80}
                        tick={{ fontSize: 12 }}
                    />
                    <YAxis tickFormatter={(value) => value.toLocaleString('en-IN')} />
                    <Tooltip content={customToolTip} />
                    <Bar dataKey={dataKeyArea.value} name={dataKeyArea.label} radius={[4, 4, 0, 0]}>
                        {dataWithColors.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.fill} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

